import classNames from "classnames";
import Link from '@/components/AppLink';
import { useMemo } from "react";
import { formatIssueTimestamp, getIssueTypeMeta } from "@/app/issues/_constants/issues.const";
import { Button } from "@/components";
import { useOverviewUnreadIssuesQuery } from "../../_hooks/useOverviewUnreadIssuesQuery";
import { OverviewSection } from "../overview-section";
import panelStates from "../overview-panel-states/OverviewPanelStates.module.scss";
import styles from "./OverviewRecentIssuesSection.module.scss";

export const OverviewRecentIssuesSection = () => {
  const { data, isLoading, isError, refetch } = useOverviewUnreadIssuesQuery();

  const items = useMemo(() => {
    const raw = data?.items ?? [];
    return raw
      .filter((issue) => !issue.read)
      .sort((a, b) => b.createdAt - a.createdAt)
      .slice(0, 4);
  }, [data?.items]);

  return (
    <OverviewSection
      title="Latest unread reports"
      href="/issues"
    >
      {isLoading ? (
        <div className={panelStates["state"]}>
          <div className={panelStates["spinner"]} />
          <span>Loading reports…</span>
        </div>
      ) : null}

      {isError && !isLoading ? (
        <div className={panelStates["state"]}>
          <span>Couldn&apos;t load reports.</span>
          <Button size="small" variant="secondary" onClick={() => refetch()}>
            Retry
          </Button>
        </div>
      ) : null}

      {!isLoading && !isError && items.length === 0 ? (
        <div className={panelStates["state"]}>No unread error reports.</div>
      ) : null}

      {!isLoading && !isError && items.length > 0 ? (
        <div className={styles["list"]}>
          {items.map((issue) => {
            const typeMeta = getIssueTypeMeta(issue.errorType);
            return (
              <Link key={issue.id} href="/issues" className={styles["row"]}>
                <div className={styles["row__main"]}>
                  <div className={styles["row__model"]}>{issue.modelSlug}</div>
                  <div className={styles["row__preview"]}>{issue.description}</div>
                </div>
                <div className={styles["row__aside"]}>
                  <span
                    className={classNames(
                      styles["badge"],
                      styles[`badge--${typeMeta.variant}`]
                    )}
                  >
                    {typeMeta.label}
                  </span>
                  <time className={styles["time"]}>
                    {formatIssueTimestamp(issue.createdAt)}
                  </time>
                </div>
              </Link>
            );
          })}
        </div>
      ) : null}
    </OverviewSection>
  );
};
